export default {"src":"/_next/static/media/notFound.6e2edd29.svg","height":440,"width":291};